import { createSlice } from "@reduxjs/toolkit";

const initialState = [];

export const slice = createSlice({
	name: "segments",
	initialState,
	reducers: { update: (state, { payload }) => [...(state || []), ...(payload || [])] },
});

export const segmentsSelector = (state) => state?.segments || [];

export const { actions, reducer } = slice;

export default reducer;
